import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import ThemeToggle from "@/components/ThemeToggle";
import { Terminal, ArrowLeft } from "lucide-react";

const LegalShell = ({ title, updated, children }) => {
  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col">
      <header className="sticky top-0 z-30 h-16 border-b border-zinc-800 bg-zinc-950 flex items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2" data-testid="legal-logo-link">
          <div className="h-8 w-8 flex items-center justify-center bg-teal-400 rounded-xl">
            <Terminal className="h-5 w-5 text-zinc-950" />
          </div>
          <span className="font-heading font-black tracking-tighter text-zinc-100">IndieLaunchkit</span>
        </Link>
        <div className="flex items-center gap-3">
          <ThemeToggle />
          <Link
            to="/"
            className="flex items-center gap-2 text-sm text-zinc-400 hover:text-teal-400 transition-colors duration-200"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="h-4 w-4" /> Back to app
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-6 py-16">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-teal-400 mb-3">// Legal</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-zinc-100">{title}</h1>
          <p className="text-zinc-500 font-mono text-sm mt-3">Last updated: {updated}</p>
          <div className="mt-10 space-y-8 legal-body">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-heading text-xl font-bold text-zinc-100 tracking-tight mb-3">{heading}</h2>
    <div className="text-zinc-400 leading-relaxed space-y-3">{children}</div>
  </section>
);

export default LegalShell;
